import React, { useState } from "react";
import { formatToNaira } from "../../helpers/utils/funtions";
import { BANK_TRANSFER_DETAILS as bank } from "./bank-transfer-details";

export function InvoiceBankTransferDetails({
  invoiceNumber,
  amountDue,
  isFullyPaid,
}: {
  invoiceNumber: number;
  amountDue: number;
  isFullyPaid: boolean;
}) {
  const [copyStatus, setCopyStatus] = useState("");
  async function copyAccountNumber() {
    try {
      await navigator.clipboard.writeText(bank.accountNumber);
      setCopyStatus("Account number copied.");
    } catch {
      setCopyStatus(
        "Could not copy. Please select and copy the account number.",
      );
    }
  }
  return (
    <section
      aria-label="Bank transfer"
      className="mt-8 rounded-lg border border-solid border-primary-150 bg-slate-50 p-5 text-primary-300"
    >
      <h3 className="text-lg font-bold !mb-2">Pay by bank transfer</h3>
      {isFullyPaid ? (
        <p>This invoice is already paid. No further transfer is needed.</p>
      ) : (
        <>
          <p>
            Transfer <strong>{formatToNaira(Math.ceil(amountDue))}</strong> to
            the account below.
          </p>
          <p>
            Use invoice <strong>#{invoiceNumber}</strong> as your payment
            reference.
          </p>
        </>
      )}
      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 my-4">
        <div>
          <dt className="text-sm">Bank</dt>
          <dd className="font-semibold">{bank.bankName}</dd>
        </div>
        <div>
          <dt className="text-sm">Account name</dt>
          <dd className="font-semibold">{bank.accountName}</dd>
        </div>
        <div>
          <dt className="text-sm">Account number</dt>
          <dd className="font-semibold text-xl">{bank.accountNumber}</dd>
        </div>
        <div className="flex items-center">
          <button
            type="button"
            onClick={copyAccountNumber}
            className="rounded border border-solid border-primary-200 px-3 py-2 text-sm font-semibold"
          >
            Copy account number
          </button>
        </div>
      </dl>
      <p role="status" aria-live="polite" className="text-sm">
        {copyStatus}
      </p>
      {!isFullyPaid && (
        <p className="text-sm !mb-0">
          Your invoice will be updated after we confirm receipt of your
          transfer.
        </p>
      )}
    </section>
  );
}
